import { render, staticRenderFns } from "./OtherTerms.vue?vue&type=template&id=58074539&scoped=true"
import script from "./OtherTerms.vue?vue&type=script&lang=js"
export * from "./OtherTerms.vue?vue&type=script&lang=js"
import style0 from "./OtherTerms.vue?vue&type=style&index=0&id=58074539&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58074539",
  null
  
)

export default component.exports